export const prefixCls = process.env.REACT_APP_PREFIX;

export enum Themes {
  'dark',
  'light',
}
